import { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Grid, LinearProgress } from '@mui/material';
import styles from './Uploader.module.css'


// const BorderLinearProgress = withStyles((theme) => ({
//   root: {
//     height: 5,
//     borderRadius: 5,
//   },
//   colorPrimary: {
//     backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
//   },
//   bar: {
//     borderRadius: 5,
//     backgroundColor: '#008d3f;',
//   },
// }))(LinearProgress);



export default function Uploader({ setPostData, postData }) {
  const [file, setFile] = useState(postData.cover);
  const [progress, setProgress] = useState(0)

    useEffect(() => {
        setPostData({...postData, cover: file})
        // eslint-disable-next-line
    },[file])

  const onDrop = useCallback((acceptedFiles) => {
    // const url = "https://api.cloudinary.com/v1_1/wabis/image/upload/";
    const url = "https://api.cloudinary.com/v1_1/wabis/image/upload";

    acceptedFiles.forEach(async (acceptedFile) => {
    //   const { signature, timestamp } = await getSignature();

      const formData = new FormData();
      formData.append("file", acceptedFile);
      formData.append(
        "upload_preset",
        "birdplus"
      );
      
      const response = await fetch(url, {
        method: "post",
        body: formData,
      });
      setProgress(100)
      const data = await response.json();
      
      setFile(data.secure_url)
      console.log(data)
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accepts: "image/*,application/pdf",
    multiple: false,
  });


  


  return (
    <>
        <div
          {...getRootProps()}
          className={`${styles.dropzone} ${isDragActive ? styles.active : null}`}
        >
          <input {...getInputProps()} />
        Upload cover picture
        </div>
        <Grid item style={{width: '100%'}}>
          {/* <p>Uploading...</p> */}
          <LinearProgress color="success" variant="determinate" value={progress} />
          {progress === 100 && (
           <img src={postData.cover} alt="cover" />
          )}
        </Grid>
      </>
  );
}
